// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1mteM","footer":"ModalError_footer__1qbt6"};